import { Component } from '@angular/core'

@Component({
  template: '<ftr-forbidden></ftr-forbidden>',
})
export class ForbiddenPage {}
